import './style.css'

// Optionally add analytics or other initialization here
console.log('KaleidoSwap - Coming Soon page loaded')
